/* eslint-disable linebreak-style */
/* eslint-disable react/function-component-definition */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/no-danger */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable quotes */
import React, { useState } from "react";
import { Link } from "react-router-dom";

import ContactIcons from "../Contact/ContactIcons";
import ContactModal from "../Contact/ContactModal";

// const { PUBLIC_URL } = process.env; // set automatically from package.json:homepage

const SideBar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section id="sidebar">
      <section id="intro">
        {/* <Link to="/" className="logo">
          <img src={`${PUBLIC_URL}/images/me.png`} alt="" />
        </Link> */}
        <header>
          <h2>Raj Chhatwani</h2>
          <p>
            <a href="mailto:rajchhatwani39@gmail.com">
              rajchhatwani39@gmail.com
            </a>
          </p>
        </header>
      </section>

      <section className="blurb">
        {/* <h2>About</h2> */}
        <p>
          Hi, I&apos;m Raj. I am pursuing B.Tech Computer Engineering from{" "}
          <a href="https://silveroakuni.ac.in">Silver Oak University.</a>{" "}
          Learnig and exploring new stuff related to web development.
        </p>
        <ul className="actions">
          <li>
            <button
              type="button"
              className="button hire-me-button"
              onClick={() => setIsModalOpen(true)}
            >
              Hire Me
            </button>
          </li>
        </ul>
      </section>

      <section id="footer">
        <ContactIcons />
        <p className="copyright">
          &copy; Raj Chhatwani <Link to="/">rajchhatwani.github.io</Link>.
        </p>
      </section>

      <ContactModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
};

export default SideBar;
